export const isUnauthorizedError = (error: any): boolean =>
	error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
